import { motion } from "framer-motion"

interface Props {
  language: "tr" | "en"
  onStart: () => void
  onLanguageChange: (l: "tr" | "en") => void
  lastDecision?: string
  lastOutcome?: string
}

export const Welcome = ({ language, onStart, onLanguageChange, lastDecision, lastOutcome }: Props) => {
  const t = language === "tr" ? {
    ritual: "GÜNLÜK RİTÜEL",
    greeting: "Hadi kafanı toparlayalım.",
    time: "2 dakika.",
    btn: "Başla",
    yesterday: "Dün şunu seçtin:",
    outcome: lastOutcome === "done" ? "✓ Yaptın" : lastOutcome === "gave_up" ? "× Vazgeçtin" : lastOutcome === "postponed" ? "→ Erteyledin" : "Sonuç girilmemiş",
  } : {
    ritual: "DAILY RITUAL",
    greeting: "Let's clear your mind today.",
    time: "2 minutes.",
    btn: "Start",
    yesterday: "Yesterday you chose:",
    outcome: lastOutcome === "done" ? "✓ Done" : lastOutcome === "gave_up" ? "× Gave up" : lastOutcome === "postponed" ? "→ Postponed" : "No outcome recorded",
  }

  return (
    <div className="app">
      <div className="header">
        <h1>DECISION ZERO</h1>
        <div className="lang">
          <button onClick={() => onLanguageChange("en")} disabled={language === "en"}>EN</button>
          <button onClick={() => onLanguageChange("tr")} disabled={language === "tr"}>TR</button>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="step-container"
        style={{ textAlign: "center" }}
      >
        <div className="completion-label" style={{ marginBottom: "16px" }}>
          {t.ritual}
        </div>

        <div className="completion-decision" style={{ marginBottom: "8px" }}>
          {t.greeting}
        </div>

        <div className="completion-tagline" style={{ marginBottom: "32px" }}>
          {t.time}
        </div>

        {lastDecision && (
          <div className="completion-others" style={{ marginBottom: "28px", textAlign: "left" }}>
            <div className="completion-others-label">{t.yesterday}</div>
            <div style={{ fontSize: "15px", color: "var(--text-primary)", marginBottom: "6px" }}>
              {lastDecision}
            </div>
            <div style={{ fontSize: "13px", color: "var(--text-muted)" }}>
              {t.outcome}
            </div>
          </div>
        )}

        <button onClick={onStart} className="btn-primary">
          {t.btn}
        </button>
      </motion.div>
    </div>
  )
}